import ComingSoon from "../components/comingSoon";
import SubcategoryList from "../views/CategoryManagement/SubcategoryList";
import { FaRegCircle } from "react-icons/fa";
import { BiSolidCategory } from "react-icons/bi";
import CategoryList from "views/CategoryManagement/CategoryList";

const CategoryRoutes = [
  {
    name: "Category Management",
    icon: <BiSolidCategory />,
    iconDown: "nc-icon nc-minimal-down",
    layout: "/admin",
    showInSidebar: true,
    subNav: [
      {
        path: "/category/list",
        title: "Category List",
        icon: <FaRegCircle />,
        component:<CategoryList />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true,
      },
      {
        path: "/subcategory/list",
        title: "Subcategory List",
        icon: <FaRegCircle />,
        component: <SubcategoryList />,
        layout: "/admin",
        name: "sub-nav",
        showInSidebar: true,
      }
    ],
  }
];


export default CategoryRoutes;
